import api from "./axios";

const resolveBrowserTimezone = () => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";
  } catch {
    return "UTC";
  }
};

export const loginRequest = async (email, password) => {
  const res = await api.post("/auth/login", {
    email,
    password,
    clientTimezone: resolveBrowserTimezone(),
  });
  return res.data;
};

export const discoverTenantsRequest = async (email) => {
  const res = await api.post("/auth/tenants", { email });
  return res.data;
};

export const forgotPasswordRequest = async (email) => {
    const res = await api.post("/auth/forgot-password", { email });
    return res.data;
};

export const confirmForgotPassword = async (verificationToken, otp) => {
    const res = await api.post("/auth/forgot-password/confirm", { verificationToken, otp });
    return res.data;
};

export const confirmForgotPasswordSetNewPassword = async (verificationToken, newPassword) => {
    const res = await api.post("/auth/forgot-password/new-password", { verificationToken, newPassword });
    return res.data;
};

export const retryOtpForgotPassword = async (verificationToken) => {
    const res = await api.post("/auth/forgot-password/resend-otp", { verificationToken });
    return res.data;
};

export const registerRequest = async (payload) => {
  const res = await api.post("/auth/register", payload);
  return res.data;
};

export const getSubscriptions = async () => {
  const res = await api.get("/website/subscriptions");
  return res.data;
};

export const confirmRegister = async (verificationToken, otp) => {
  const res = await api.post("/auth/register/confirm", { verificationToken, otp });
  return res.data;
};

export const retryOtpRegister = async (verificationToken) => {
    const res = await api.post("/auth/register/resend-otp", { verificationToken });
    return res.data;
};

export const refreshTokenRequest = async () => {
    const res = await api.post("/auth/refresh-token");
    return res.data;
};

export const logoutRequest = async () => {
    const res = await api.post("/auth/logout");
    return res.data;
};

export const changePasswordRequest = async (currentPassword, newPassword) => {
    const res = await api.post("/auth/change-password", { currentPassword, newPassword });
    return res.data;
};
